<img [src]="url | safe: 'resourceUrl'" style="max-width: 100%; max-height: 100%; cursor: pointer;" (click)="imageClick()">